module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.downloadPercentage > 0 || _vm.uploadPercentage > 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.downloading),
      expression: "!downloading"
    }],
    staticClass: "file-progress"
  }, [(_vm.downloadPercentage > 0 && _vm.downloadPercentage > 100) ? _c('div', [_c('div', {
    staticClass: "bar",
    style: ({
      'width': _vm.percentage + '%'
    })
  }), _vm._v(" "), _c('span', [_vm._v("Protecting: " + _vm._s(_vm.percentage) + "%")])]) : _vm._e(), _vm._v(" "), (_vm.uploadPercentage > 0) ? _c('div', [_c('div', {
    staticClass: "bar",
    style: ({
      'width': _vm.uploadPercentage + '%'
    })
  }), _vm._v(" "), _c('span', [_vm._v("Transferring: " + _vm._s(_vm.uploadPercentage) + "%")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c2f8484!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/file-progress/FileProgress.vue
// module id = 1981
// module chunks = 2